var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterfallChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46216 0C10.2685 0.000141389 10.9223 0.671075 10.9225 1.49839V7.81534H12.5397C13.3461 7.81548 14 8.48627 14 9.31373V11.8408C13.9997 12.668 13.3459 13.339 12.5397 13.3392H10.6929C9.88661 13.3391 9.23285 12.668 9.23256 11.8408V9.31373H7.84496V13.5016C7.84477 14.3289 7.19092 14.9999 6.38464 15H4.53784C3.78179 15 3.16019 14.41 3.08536 13.6545L3.07752 13.5016V9.31373H1.46032C0.653809 9.31373 0 8.64287 0 7.81534V4.65686C0.000185311 3.82949 0.653924 3.15847 1.46032 3.15847H3.30712C4.1134 3.15862 4.76726 3.82958 4.76744 4.65686V7.81534H6.15504V1.49839C6.15519 0.671021 6.80899 5.28821e-05 7.61536 0H9.46216ZM4.53784 13.5016H6.38464V9.31373H4.53784V13.5016ZM10.6929 11.8408H12.5397V9.54785H10.6929V11.8408ZM1.46032 7.81534H3.30712V4.65686H1.46032V7.81534ZM7.61536 7.81534H9.46216V1.49839H7.61536V7.81534Z",
    fill: "#0B6B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfallChart);
export default __webpack_public_path__ + "static/media/WaterfallChart.d2188fd6dfc27b125109fddfa7798b98.svg";
export { ForwardRef as ReactComponent };